const discount = {
  state:{
    price_display_discount:false,
    home_page_display_discount:false,
    discount_zone:false
  },
  getters:{
    price_display_discount: state => state.price_display_discount,
    home_page_display_discount: state =>state.home_page_display_discount
  },
  mutations:{
    changePriceDisplay(state,price_display_discount){
      state.price_display_discount = price_display_discount
    },
    changeHomePage(state,home_page_display_discount){
      state.home_page_display_discount = home_page_display_discount
    },
    changeDiscountZone(state,discount_zone){
      state.discount_zone = discount_zone
    }
  }
}
export default discount



// WEBPACK FOOTER //
// ./src/stroe/modules/discount.js